import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	button: {
		id: 'polaris-ideas.idea-view.restore.button',
		defaultMessage: 'Restore',
		description: 'Text for the Restore button',
	},
});
